import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.Zoo;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "Zoo.Phaser.IntroductionScene.1",
            "Zoo.Phaser.IntroductionScene.2",
            "Zoo.Phaser.IntroductionScene.3",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/ZooGame/scenes/GameIntro.ts